import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { IoOpenOutline } from "react-icons/io5";
import Main from "../../components/layout/Main";
import { CAMERA_PATHS } from "./paths";
import "../../assets/styles/app-camera.css";

// The hosted camera viewer (app/screens/cam/CamWebView.js). hikvision.hashh.io
// sends no X-Frame-Options or frame-ancestors, so it shows in a frame here;
// the header also opens it in a new tab. Location state: { url, title }.
function CamWebView() {
  const { state } = useLocation();
  const url = state?.url;
  if (!url) return <Redirect to={CAMERA_PATHS.LIST} />;

  return (
    <Main
      header="stack"
      title={state.title || "Camera"}
      hideTabBar
      headerRight={
        <a className="hx-icon-btn" href={url} target="_blank" rel="noopener noreferrer" aria-label="Open in a new tab">
          <IoOpenOutline />
        </a>
      }
    >
      <iframe
        className="hx-cam-frame"
        src={url}
        title={state.title || "Camera"}
        allow="autoplay; fullscreen"
        allowFullScreen
        referrerPolicy="no-referrer"
      />
    </Main>
  );
}

export default CamWebView;
